import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'components/Accordion';

type LoadSectionAccordionItemProps = {
  icon: React.ReactNode;
  children: React.ReactNode;
  label: string;
  name: string;
  activeTabs: string[];
  /** Shown inline after the label inside the accordion header (e.g. help tooltip). */
  labelAccessory?: React.ReactNode;
};

export function LoadSectionAccordionItem({
  icon,
  children,
  name,
  label,
  activeTabs,
  labelAccessory,
}: LoadSectionAccordionItemProps) {
  return (
    <AccordionItem value={name}>
      <AccordionTrigger icon={icon}>
        <span className='flex flex-row items-center gap-1.5'>
          {label}
          {labelAccessory}
        </span>
      </AccordionTrigger>
      <AccordionContent
        forceMount={true}
        hidden={!activeTabs.includes(name)}
        className='grid grid-cols-1 gap-3 w-full m-0'
      >
        {children}
      </AccordionContent>
    </AccordionItem>
  );
}
